import React from 'react';
import '../styles/title.css'; 

export default function TitleSection() {
  return (
    <section className="title">
      <img
        src="/dibujos/optimized/portafolio_final.png"
        alt="Ilustración principal"
        className="title-image"
        loading="lazy"
      />
     
    </section>
  );
}